var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "with-icon" },
    [
      _c("font-awesome-icon", {
        staticClass: "icon",
        class: { "text-primary": _vm.primary },
        attrs: { icon: [_vm.iconCollection, _vm.icon] }
      }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }